import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export const WorkspacesIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g clipPath="url(#c6nszujd8a_workspaces_icon)">
      <path
        d="M6 13c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6-10C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6 10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="c6nszujd8a_workspaces_icon">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
);
